import { useMutation } from '@tanstack/vue-query'

interface PaymentNotificationParams {
  type: 'failed' | 'abandoned' | 'initiated'
  packageId?: string
}

export const useSendPaymentFailedNotification = () => {
  const authStore = useAuthStore()

  return useMutation({
    mutationFn: async (params: PaymentNotificationParams) => {
      const { type, packageId } = params

      return await $fetch('/api/payment/failed', {
        method: 'POST',
        body: {
          userId: authStore.getUser?.id,
          leadId: authStore.getUser?.leadId,
          name: `${authStore.getUser?.firstName} ${authStore.getUser?.lastName}`,
          type,
          packageId,
        },
      })
    },
  })
}

export default useSendPaymentFailedNotification
